import * as React from "react";
import { buildClasses } from "../../utils/classes";
import RadioButton from "./RadioButton";

export default function BinaryRadioButton({
  name,
  labelTrue,
  labelFalse,
  checked,
  onChange,
  additionalClass,
}: {
  name: string;
  labelTrue: string;
  labelFalse: string;
  checked: boolean;
  onChange: (state: boolean) => void;
  additionalClass?: string;
}) {
  return (
    <div
      className={buildClasses(
        {
          [additionalClass]: () => !!additionalClass,
        },
        "radio-container"
      )}
    >
      <div className="h-flex space-between">
        <RadioButton
          name={name}
          value={"true"}
          id={name + "radioTrue"}
          checked={checked}
          label={labelTrue}
          onChange={() => onChange(true)}
        />
        <RadioButton
          name={name}
          value={"false"}
          id={name + "radioFalse"}
          checked={!checked}
          label={labelFalse}
          onChange={() => onChange(false)}
        />
      </div>
    </div>
  );
}
